import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight, faChevronLeft, faChevronRight, faHandshakeSimpleSlash, faMagnifyingGlass, faStar, faUsers } from '@fortawesome/free-solid-svg-icons';
import "./knowledge.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { faBookmark, faCalendar, faEye, faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import { Rating } from '@mui/material';
import { apiService } from '../../services/apiService';
import KnowledgeCategory from '../../components/common/KnowledgeCategory';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';
import { toast } from 'react-toastify';
import { eventBus } from '../../components/eventBus';
function KnowledgeArticle() {
    const navigate = useNavigate();
    const initialId = localStorage.getItem('knowledgeBackId'); // Use initial state from location
    const [id, setId] = useState(initialId || "");
    const [refetches,Setrefetcher] = useState(id);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleToggle = (value) => {
            setIsVisible(value);
        };
        eventBus.on('toggleCategory', handleToggle);
        return () => {
            eventBus.off('toggleCategory', handleToggle);
        };
    }, []);

    const hideFromChild = () => {
        eventBus.emit('hideCategory');
    };
    // const toggleVisibility = () => {
    //     setIsVisible(!isVisible);
    // };
    // const closeElement = () => {
    //     setIsVisible(false);
    // };
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [reroute, setReroute] = useState();
    const [subcatSend, setSubcatsSend] = useState(refetches);

    const catId = localStorage.getItem('knowledgeCatBackId'); // Use initial state from location
    const [catid, setCatId] = useState(catId || "");
    const [refetchescatid,Setrefetchercatid] = useState(catid);
    const [catSend, setSelectedCategory] = useState(refetchescatid);

    const kbaseId = localStorage.getItem('knowledgeKbaseBackId'); // Use initial state from location
    const [kbaseid, setKbaseId] = useState(kbaseId || "");
    const [refetcheskbaseid,SetrefetcherKbaseid] = useState(kbaseid);
    const [kbaseidSend, setSelectedKbaseId] = useState(refetcheskbaseid);
    
    const handleKbaseSelect = (kBaseId) => {
        setSelectedKbaseId(kBaseId);
        setSelectedCategory("");
        setSubcatsSend("");
    };
    const handleCategorySelect = (categoryId) => {
        setSelectedCategory(categoryId);
        setSubcatsSend("");
        setSelectedKbaseId("");
    };
    const handleSubCategorySelect = (subCategoryId) => {
        setSubcatsSend(subCategoryId);
        setSelectedCategory("");
        setSelectedKbaseId("");
        hideFromChild();
    };

    // const [searchQuery, setSearchQuery] = useState("");
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const fetchSuggestions = async (query) => {
        if (!query) {
        //   setSuggestions([]); // Clear suggestions if input is empty
            return;
        }
    
        try {
            const response = await apiService.postRequest("knowledge-article/search-suggestions", { query });
            if(response && response.success){
            setFilteredSuggestions(response.suggestions || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (value) {
            fetchSuggestions(value);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setSearchQuery(suggestion);
        setShowSuggestions(false);
    };
    
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (e.key === "ArrowUp" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (e.key === "Enter") {
            if (activeIndex >= 0) {
                const selected = filteredSuggestions[activeIndex];
                setSearchQuery(selected.title);
                setShowSuggestions(false);
            }
            handleSearch();
        }
    };
    const fetchArticles = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {base_id: kbaseidSend,category_id: catSend, subcategory_id: subcatSend ,...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/knowledge-list-articles?${queryString}`);
            if (response && response.success === true) {
                setArticles(response.data);
                setReroute(response);
                setPaginateData(response.meta);
                Setrefetcher("");
                Setrefetchercatid("");
                SetrefetcherKbaseid("");
                setId('');
                setCatId('');
                setKbaseId('');
            }else{
                setArticles([]);
                toast(response.message || "Something went wrong!");
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            localStorage.removeItem('knowledgeBackId');
            localStorage.removeItem('knowledgeCatBackId');
            localStorage.removeItem('knowledgeKbaseBackId');
            setLoading(false);
        }
    }, [kbaseidSend,catSend,subcatSend]);
  
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchArticles({ page: newPage });  
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchArticles({ search: searchQuery });
    };

    useEffect(() => {
        fetchArticles();
    }, [fetchArticles]);

    const handleSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/add',params);
            if(response && response.success === true){
                fetchArticles({ page: currentPage, search: searchQuery });
                toast(response.message || 'Bookmarked successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to save job");
        }
    };
    const handleRemoveSave = async (saveid) => {
        try {
            const params = ({
                article_id : saveid
            })
            const response = await apiService.postRequest('/bookmark/remove',params);
            if(response && response.success === true){
                fetchArticles({ page: currentPage, search: searchQuery });  
                toast(response.message || 'Remove Bookmark successfully!');
            }else{
                toast(response.message || 'Failed, try again!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            toast.error("Failed to Unsave job");
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <div className="d-lg-block d-none"> 
                <ResizableBox 
                    className="knowledge-category"
                    width={400}    
                    height={Infinity}  
                    minConstraints={[400, Infinity]}
                    maxConstraints={[window.innerWidth - 800, Infinity]}
                    axis="x"
                    resizeHandles={['e']}
                    >
                    <div className="knowledge-category-content">
                        <KnowledgeCategory 
                            // onClose={closeElement} 
                            onCategorySelect={handleCategorySelect} 
                            onSubCategorySelect={handleSubCategorySelect} 
                            onKbaseSelect={handleKbaseSelect}
                            selectedKbaseId={reroute && reroute.base_id}
                            selectedCategory={reroute && reroute.category_id}
                            selectedSubCategory={reroute && reroute.subcategory_id}
                        />
                    </div> 
                </ResizableBox>
            </div>
            <div className="d-lg-none d-block">
                <div className={isVisible !== true ? 'hide_mobitr' : 'show_mobitr'}>
                    <KnowledgeCategory onCategorySelect={handleCategorySelect} onSubCategorySelect={handleSubCategorySelect} onKbaseSelect={handleKbaseSelect} />
                </div>
            </div>  
            <div className='content_container_articals_drag' style={{ flexGrow: 1 }}>
                <Grid size={{sm:12}} container className="main_jobseeker" style={{background:"#fff"}}>
                    <Grid size={{sm:12}} container alignItems="center">
                        <Grid size={{xs:12}} container flexDirection="column" className="jobseekerhead">
                            <h3>Knowledge Article</h3>
                            <span className='d-lg-flex d-none'>
                                <b onClick={() => navigate("/dashboard")}>Dashboard</b> 
                                <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 

                                <b onClick={() => { 
                                    setSelectedKbaseId(""); 
                                    setSelectedCategory(""); 
                                    setSubcatsSend("");
                                    setSearchQuery("");
                                    fetchArticles({ page: "", search: "" });
                                }}>All Articles</b>

                                {reroute?.base_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSelectedCategory(""); 
                                            setSubcatsSend(""); 
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.base_name}
                                        </b>
                                    </>
                                )}

                                {reroute?.category_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSelectedCategory(reroute.category_id); 
                                            setSubcatsSend(""); 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.category_name}
                                        </b>
                                    </>
                                )}

                                {reroute?.subcategory_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSubcatsSend(reroute.subcategory_id); 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSelectedCategory(reroute.category_id);
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.subcategory_name}
                                        </b>
                                    </>
                                )}
                            </span>
                            <span className='d-lg-none d-block wrap_ellipseset'>
                                <b onClick={() => { 
                                    setSelectedKbaseId(""); 
                                    setSelectedCategory(""); 
                                    setSubcatsSend(""); 
                                    setSearchQuery("");
                                    fetchArticles({ page: "", search: "" });
                                }}>All Articles</b>

                                {reroute?.base_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSelectedCategory(""); 
                                            setSubcatsSend(""); 
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.base_name}
                                        </b>
                                    </>
                                )}

                                {reroute?.category_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSelectedCategory(reroute.category_id); 
                                            setSubcatsSend(""); 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.category_name}
                                        </b>
                                    </>
                                )}

                                {reroute?.subcategory_id && (
                                    <>
                                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                                        <b onClick={() => { 
                                            setSubcatsSend(reroute.subcategory_id); 
                                            setSelectedKbaseId(reroute.base_id); 
                                            setSelectedCategory(reroute.category_id);
                                            setSearchQuery("");
                                            fetchArticles({ page: "", search: "" });
                                        }}>
                                            {reroute.subcategory_name}
                                        </b>
                                    </>
                                )}
                            </span>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container justifyContent="space-between" alignItems="center" className="my-4">
                            <Grid size={{md:5,sm:7,xs:12}} container flexDirection="column">
                                <div className="d-flex jobseekersearch my-lg-3" style={{ position: "relative" }}>
                                    <div className="col-2">
                                        <FontAwesomeIcon className="iconcol" icon={faMagnifyingGlass} />
                                    </div>
                                    <div className="col-7">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyDown}
                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                            onFocus={() => searchQuery && setShowSuggestions(true)}
                                        />
                                        {showSuggestions && (
                                            <ul className="suggestions-dropdown">
                                                {filteredSuggestions.length > 0 ? (
                                                    filteredSuggestions.map((suggestion, index) => (
                                                        <li
                                                            key={index}
                                                            className={index === activeIndex ? "active" : ""}
                                                            onMouseDown={() => handleSuggestionClick(suggestion.title)}
                                                        >
                                                            {suggestion.title}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="no-suggestions">No results found</li>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                    <div className="col-3">
                                        <button onClick={handleSearch}>Search</button>
                                    </div>
                                </div>
                            </Grid>
                            <button className='download_csvbtndatatable mb-0 d-lg-block d-none' onClick={()=>navigate("/knowledge/bookmark")}><FontAwesomeIcon icon={faBookmark} className='me-2'/>My Bookmarks</button>
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mb-4">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {articles && articles.length > 0 ? (
                            articles && articles.map((article) => ( 
                            <Grid key={article.id} size={{sm:12}} container justifyContent="center" className="knowledge_lister my-lg-4 mb-4">
                                <Link style={{cursor:"pointer",textDecoration:"none"}} className='questionskn' to={`/knowledge-article/${article.format_id}`}><b className="articleformat_id">{article.format_id}</b> {article.title}</Link>
                                <span className='w-100 mb-3 discript_article'>
                                    {article.short_description
                                    ? article.short_description.slice(0, 300) + (article.short_description.length > 300 ? "..." : "")
                                    : "No Data"}
                                </span>
                                <Grid size={{xs:12}} container className="span_griders d-lg-block d-none">
                                    <span><FontAwesomeIcon icon={faUser} className='icon_kn'/><small>Authored by :</small>{article.author.name}</span>
                                    <span><FontAwesomeIcon icon={faUsers} className='icon_kn'/><small>Group :</small>{article.owned_by_group}</span>
                                    <span><FontAwesomeIcon icon={faEye} className='icon_kn'/>{article.view_count}</span>
                                    <span><FontAwesomeIcon icon={faHandshake} className='icon_kn'/>{article.helpful_true_count} Helpful</span>
                                    <span><FontAwesomeIcon icon={faHandshakeSimpleSlash} className='icon_kn'/>{article.helpful_false_count} UnHelpful</span>
                                    {article.is_bookmarked ?
                                        <span style={{cursor:"pointer"}} onClick={() => handleRemoveSave(article.id)}><img style={{width:"18px",marginRight:"10px"}} src={require("../../assets/sample/save_tagpink.svg").default} alt="save"/>Bookmarked</span>:
                                        <span style={{cursor:"pointer"}} onClick={() => handleSave(article.id)}><FontAwesomeIcon icon={faBookmark} className='icon_kn'/>Bookmark</span>
                                    }
                                    <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                                    <Rating className='rating_spanhiders' disabled value={JSON.parse(article.overall_rating)} />
                                </Grid>
                                <Grid size={{xs:12}} container className="span_griders d-lg-none">
                                    <span><FontAwesomeIcon icon={faUser} className='icon_kn'/>{article.author.name}</span>
                                    <span><FontAwesomeIcon icon={faEye} className='icon_kn'/>{article.view_count}</span>
                                    <span><FontAwesomeIcon icon={faCalendar} className='icon_kn'/>{article.created_at}</span>
                                    <span><FontAwesomeIcon icon={faStar} className='icon_kn_yellow'/>{JSON.parse(article.overall_rating)}</span>
                                </Grid>
                            </Grid>
                            ))
                        ) : ( 
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                    </>}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                        <button className='arrowpaginate' 
                            onClick={() => handlePageChange(currentPage - 1)} 
                            disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        {paginatedata && (
                            <div className="pagination">
                                {(() => {
                                const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                const pages = [];
                                const start = Math.max(2, currentPage - 2);
                                const end = Math.min(totalPages - 1, currentPage + 2);

                                // Always show first page
                                pages.push(
                                    <button
                                    key={1}
                                    onClick={() => handlePageChange(1)}
                                    className={currentPage === 1 ? 'active' : ''}
                                    >
                                    1
                                    </button>
                                );

                                if (start > 2) {
                                    pages.push(<span key="start-ellipsis">...</span>);
                                }

                                for (let i = start; i <= end; i++) {
                                    pages.push(
                                    <button
                                        key={i}
                                        onClick={() => handlePageChange(i)}
                                        className={currentPage === i ? 'active' : ''}
                                    >
                                        {i}
                                    </button>
                                    );
                                }

                                if (end < totalPages - 1) {
                                    pages.push(<span key="end-ellipsis">...</span>);
                                }

                                if (totalPages > 1) {
                                    pages.push(
                                    <button
                                        key={totalPages}
                                        onClick={() => handlePageChange(totalPages)}
                                        className={currentPage === totalPages ? 'active' : ''}
                                    >
                                        {totalPages}
                                    </button>
                                    );
                                }

                                return pages;
                                })()}
                            </div>
                            )}


                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage + 1)} 
                            disabled={currentPage === paginatedata.last_page}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    </div>
  )
}

export default KnowledgeArticle
